import React, { useState, useEffect } from 'react'
import { Card, CardBody, CardHeader } from '../../../../_metronic/_partials/controls'
import {
    Button,
    TextField,
    Typography,
    Dialog, DialogActions, DialogContent, DialogTitle
} from '@material-ui/core'
import { useHistory, useParams } from 'react-router-dom'
import { getTechnologyById, updateTechnology, postTechnology } from '../../../../api/technology'
import MultilanguageTabBlock from '../../../components/MultilanguageTabBlock'
import { useSkeleton } from '../../../hooks/useSkeleton'
import { alertError, alertSuccess } from '../../../../utils/logger'
import Editor from '../../../components/editor/Editor'
import LogoSection from '../../../components/UploadLogo'
import TableTypeTech from './TableTypeTech'


function getEmptyText() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        description: {
            'es': "",
            'en': ""
        },
        logoURL: ''
    }
}

function getEmptyTechType() {
    return {
        title: {
            'es': "",
            'en': ""
        },
        order: -1
    };
}

function typeDialog(typesOpen, setTypesOpen, typeSelected, setTypeSelected, typesData, setTypesData, setTableKey) {

    const dialogTitle = typeSelected.order < 0 ? "Create type" : "Edit type";


    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!typeSelected[element])
                typeSelected[element] = {}
            let newText = typeSelected[element]
            newText[lang] = event.target.value
            setTypeSelected({ ...typeSelected, [element]: newText })
        } else
            setTypeSelected({ ...typeSelected, [element]: event.target.value })
    }

    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <TextField
                    label="Title"
                    value={(typeSelected.title && typeSelected.title[lang]) || ''}
                    onChange={handleChange('title', lang)}
                    margin="normal"
                    variant="outlined"
                    required
                />
            </>
        )
    }

    return (
        <Dialog
            open={typesOpen}
            onClose={() => setTypesOpen(false)}
            aria-labelledby="confirm-dialog"
            PaperProps={{
                style: {
                    width: '40vw',
                    height: '40vh',
                    maxWidth: 'none'
                }
            }}>
            <DialogTitle id="confirm-dialog">{dialogTitle}</DialogTitle>
            <DialogContent style={{ overflowX: 'hidden' }}>
                <MultilanguageTabBlock
                    multilanguageTabContent={renderMultilanguageTabContent}
                />
            </DialogContent>
            <DialogActions>
                <Button
                    variant="outlined"
                    color="primary"
                    onClick={() => {
                        if (!typeSelected.title?.es || typeSelected.title?.es.trim() === '') {
                            alertError({ customMessage: "Spanish title is required." });
                            return;
                        }

                        if (typeSelected.title?.en === '' || typeSelected.title?.en === '') {
                            alertError({ customMessage: "English title is required." });
                            return;
                        }


                        if (dialogTitle.includes("Create")) {
                            typeSelected.order = 1;
                            setTypesData([...typesData, typeSelected]);

                        } else {
                            const updatedData = typesData.map((item, index) =>
                                index === typeSelected.title?.en ? typeSelected : item
                            );
                            setTypesData(updatedData);
                        }
                        setTableKey(k => k + 1);
                        setTypeSelected(getEmptyTechType())
                        setTypesOpen(false)
                    }}
                >
                    Save
                </Button>
                <Button
                    variant="outlined"
                    color="secondary"
                    onClick={() => {
                        setTypesOpen(false)
                    }}
                >
                    Close
                </Button>
            </DialogActions>
        </Dialog>
    )
}

export default function EditTechnologyPage() {
    const technologyId = useParams().id;
    const history = useHistory();
    const { isLoading: isLoadingData, disableLoading: disableLoadingData, ContentSkeleton } = useSkeleton();

    const [technology, setTechnology] = useState(getEmptyText())

    const [selectedLogo, setSelectedLogo] = useState(null);
    const [openPreviewDialog, setOpenPreviewDialog] = useState(null);

    const [typesData, setTypesData] = useState([])
    const [typesOpen, setTypesOpen] = useState(false);
    const [typeSelected, setTypeSelected] = useState(getEmptyTechType())
    const [tableKey, setTableKey] = useState(0);


    useEffect(() => {
        if (!technologyId) {
            disableLoadingData();
            return // history.push('/technologies');
        }

        getTechnologyById(technologyId).then(res => {
            setTypesData(res.data.optionTypes)
            setTechnology(res.data)
            disableLoadingData()
        }).catch(error => {
            alertError({ error: error, customMessage: 'Could not get technology.' })
            history.push('/technologies')
        })
    }, [technologyId, disableLoadingData, history])

    function saveTechnology() {
        technology.optionTypes = typesData.map(item => ({ title: item.title }));

        if (!technologyId) {
            postTechnology(technology, selectedLogo)
                .then((res) => {
                    alertSuccess({
                        title: "Saved!",
                        customMessage: "Technology created successfully.",
                    });
                    history.push("/technologies");
                })
                .catch((error) => {
                    alertError({
                        error: error,
                        customMessage: "Could not save the technology.",
                    });
                });
        } else {
            updateTechnology(technologyId, technology, selectedLogo).then(res => {
                alertSuccess({ title: 'Saved!', customMessage: 'Changes successfully saved.' })
                history.push('/technologies')
            }).catch(error => {
                alertError({ error: error, customMessage: 'Could not save changes.' })
            })
        }
    }

    const handleChange = (element, lang) => (event) => {
        if (lang) {
            if (event.target.value === ' ')
                return
            if (!technology[element])
                technology[element] = {}
            let newText = technology[element]
            newText[lang] = event.target.value
            setTechnology({ ...technology, [element]: newText })
        } else
            setTechnology({ ...technology, [element]: event.target.value })
    }

    const handleChangeEditor = (element, lang, value) => {
        if (lang) {
            if (value === ' ')
                return
            if (!technology[element])
                technology[element] = {}
            let newText = technology[element]
            newText[lang] = value
            setTechnology({ ...technology, [element]: newText })
        } else
            setTechnology({ ...technology, [element]: value })
    }


    const renderMultilanguageTabContent = lang => {
        return (
            <>
                <div className="d-flex align-items-center mt-5">
                    <div className='col-8'>
                        <TextField
                            label="Title"
                            value={(technology.title && technology.title[lang]) || ''}
                            onChange={handleChange('title', lang)}
                            margin="normal"
                            variant="outlined"
                            required
                        />
                    </div>
                    <div className="col-4">
                        <LogoSection
                            selectedLogo={selectedLogo}
                            setSelectedLogo={setSelectedLogo}
                            objectClass={technology}
                            setObjectClass={setTechnology}
                            openPreviewDialog={openPreviewDialog}
                            setOpenPreviewDialog={setOpenPreviewDialog}
                        />
                    </div>
                </div>

                <div className="col-12">
                    <Editor
                        body={(technology.description && technology.description[lang]) || ''}
                        setBody={new_body => handleChangeEditor('description', lang, new_body)}
                        className='max-height'
                        lang={lang}
                        placeholder={'Enter text content here...'}
                    />
                </div>

            </>
        )
    }

    if (isLoadingData)
        return <ContentSkeleton />

    return (
        <>
            <Card>
                <CardHeader title='Edit technology'>
                </CardHeader>
                <CardBody>
                    <MultilanguageTabBlock
                        multilanguageTabContent={renderMultilanguageTabContent}
                    />

                    <div className="d-flex align-item-center mt-5">
                        <div className="col-3">
                            <Typography variant="h6" color="text.secondary">
                                Technology Types
                            </Typography>
                        </div>
                        <div className="col-8" />
                        <div className="d-flex justify-content-end col-1">
                            <button
                                type="button"
                                className="btn btn-primary text-white"
                                onClick={() => {
                                    setTypeSelected(getEmptyTechType());
                                    setTypesOpen(true);
                                }}

                            >
                                Add new
                            </button>
                        </div>
                    </div>

                    <TableTypeTech
                        data={typesData}
                        setData={setTypesData}
                        setTypesOpen={setTypesOpen}
                        setTypeSelected={setTypeSelected}
                        tableKey={tableKey}
                        setTableKey={setTableKey}
                    />

                    {typeDialog(typesOpen, setTypesOpen, typeSelected, setTypeSelected, typesData, setTypesData, setTableKey)}
                </CardBody>
            </Card>
            <Button
                onClick={() => history.push('/technologies')}
                variant="outlined"
                style={{ marginRight: '20px' }}>
                Back
            </Button>
            <Button
                onClick={() => saveTechnology()}
                variant="outlined"
                color="primary"
                style={{ marginRight: '20px' }}>
                Save technology
            </Button>

        </>
    );
}